import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import PageHeader from "@/components/common/PageHeader";
import { GALLERY } from "@/data/content";

const CATS = ["All", ...Array.from(new Set(GALLERY.map((g) => g.cat)))];

const Gallery = () => {
  const [cat, setCat] = useState("All");
  const [lightbox, setLightbox] = useState(null);
  const list = cat === "All" ? GALLERY : GALLERY.filter((g) => g.cat === cat);

  return (
    <div>
      <PageHeader
        eyebrow="Gallery"
        title="Inside our workshop & field operations"
        subtitle="Machines, retrofits, installations, automation panels and the team that makes it happen."
        image="https://images.unsplash.com/photo-1655393001768-d946c97d6fd1?auto=format&fit=crop&w=1400&q=80"
      />
      <section className="py-8 md:py-12">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="flex flex-wrap gap-3 mb-10">
            {CATS.map((c) => (
              <button key={c} onClick={() => setCat(c)} data-testid={`gcat-${c}`}
                className={`px-5 py-2.5 rounded-full text-sm border transition-all ${cat === c ? "bg-[#0055FF] border-[#0055FF]" : "border-slate-200 text-slate-600 hover:border-slate-400"}`}>{c}</button>
            ))}
          </div>
          <motion.div layout className="columns-1 sm:columns-2 lg:columns-3 gap-4 [column-fill:_balance]">
            {list.map((g, i) => (
              <motion.button layout key={g.src + i} onClick={() => setLightbox(g.src)}
                initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: (i % 6) * 0.05 }}
                className="group relative mb-4 block w-full overflow-hidden rounded-2xl border border-slate-200" data-testid={`gallery-item-${i}`}>
                <img src={g.src} alt={g.cat} className="w-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-5">
                  <span className="text-sm font-medium text-white">{g.cat}</span>
                </div>
              </motion.button>
            ))}
          </motion.div>
        </div>
      </section>

      <AnimatePresence>
        {lightbox && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-6" onClick={() => setLightbox(null)} data-testid="lightbox">
            <button className="absolute top-6 right-6 text-white" onClick={() => setLightbox(null)}><X className="w-8 h-8" /></button>
            <motion.img initial={{ scale: 0.9 }} animate={{ scale: 1 }} src={lightbox} alt="" className="max-h-[85vh] max-w-full rounded-2xl object-contain" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
